import { ArrowUpRight, MessageCircle } from "lucide-react";
import { useI18n } from "@/i18n";

const WHATSAPP_NUMBER = "971542005570";

function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function CTAInquiry() {
  const { t } = useI18n();
  const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hello Prime Zone FZCO, I'd like to inquire about wholesale mobile phones / accessories."
  )}`;

  return (
    <section data-testid="cta-inquiry-section" className="relative py-20 md:py-28">
      <div className="relative max-w-6xl mx-auto px-6 md:px-10">
        <div className="relative overflow-hidden rounded-[32px] glass-strong p-10 md:p-16 text-center reveal" style={{ boxShadow: "0 60px 120px rgba(22,75,255,0.18), inset 0 1px 0 rgba(255,255,255,0.1)" }}>
          <div className="glow-blue animate-pulseGlow" style={{ width: 520, height: 520, left: -120, top: -120, background: "radial-gradient(circle at center, rgba(22,75,255,0.55), transparent 60%)" }} />
          <div className="glow-blue animate-pulseGlow" style={{ width: 520, height: 520, right: -120, bottom: -120, background: "radial-gradient(circle at center, rgba(122,92,255,0.45), transparent 60%)" }} />

          <div className="relative">
            <div className="pill mx-auto">
              <span className="w-1.5 h-1.5 rounded-full bg-[#7A5CFF] shadow-[0_0_10px_rgba(122,92,255,0.9)]" />
              <span className="tracking-[0.2em] uppercase text-[11px]">{t("cta.badge")}</span>
            </div>
            <h2 data-testid="cta-headline" className="mt-6 font-display text-4xl md:text-6xl font-extrabold tracking-tight text-white leading-[1.04]">
              {t("cta.title_a")} <span className="text-gradient-brand">{t("cta.title_b")}</span>
            </h2>
            <p className="mt-5 max-w-2xl mx-auto text-[15.5px] md:text-[16.5px] text-[#A8A8B3] leading-relaxed">
              {t("cta.body")}
            </p>
            <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
              <button data-testid="cta-request-quote" onClick={() => scrollTo("contact")} className="btn-primary">
                {t("common.request_quote")} <ArrowUpRight className="w-4 h-4" />
              </button>
              <a data-testid="cta-whatsapp" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="btn-ghost">
                <MessageCircle className="w-4 h-4" />
                {t("cta.whatsapp_btn")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
